function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e30512;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M0,21.33c0,11.78,9.55,21.33,21.33,21.33s21.33-9.55,21.33-21.33S33.11,0,21.33,0,0,9.55,0,21.33"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M12,14.59l-7.01-6.98c.69-.82,1.44-1.58,2.24-2.28l7.03,7.01-2.26,2.26Z"
})), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "13.17 15.75 15.43 13.49 26.68 24.7 27.53 27.8 24.42 26.96 13.17 15.75"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M28.53,25.22c.06,0,.11-.02.17-.02,2.08,0,3.77,1.69,3.77,3.77s-1.69,3.77-3.77,3.77-3.77-1.69-3.77-3.77c0-.06,0-.11,0-.17l3.55.96c.07.02.14.03.22.03.22,0,.43-.08.58-.24.21-.21.29-.51.21-.8l-.97-3.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M3.98,8.92l17.29,17.22L0,20.61c.15-4.36,1.6-8.38,3.97-11.69"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M23.31,28.37c-.02.2-.03.4-.03.6,0,1.98,1.07,3.71,2.66,4.65l-4.92,9.03C9.7,42.5.51,33.54,0,22.31l23.31,6.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M27.48,34.24c.39.09.8.14,1.22.14,2.24,0,4.17-1.37,4.99-3.32l5.75,1.5c-3.5,5.63-9.54,9.51-16.52,10.03l4.55-8.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M31.12,24.13c-.73-.36-1.55-.58-2.42-.58-.26,0-.52.02-.77.06L8.51,4.28C12.07,1.6,16.51,0,21.31,0,28.72,0,35.25,3.79,39.07,9.53l-7.96,14.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M34.09,29.47c.02-.17.03-.33.03-.5,0-1.52-.63-2.9-1.65-3.88l7.59-13.93c1.64,3.02,2.58,6.49,2.58,10.18s-.86,6.82-2.36,9.75l-6.19-1.61Z"
}))));

var SvgESign = function SvgESign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 42.66 42.66",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgESign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eSign.06fd4cdd.svg";
export { ForwardRef as ReactComponent };